import { Box, Stack, styled } from "@mui/material"
import {
  CollapsibleBlock,
  CollapsibleGroup,
  EmptySection,
  isDefined,
} from "@pharmupp/p3-front-commons"
import {
  HealthMissionCard,
  HealthMissionCategoryHeader,
  type HealthMissionsView,
} from "../../HealthMissions"
import { SyncDate } from "./commons"

const VISIBLE_MISSIONS = 3

export const HealthMissionsMyPharmacySection = ({
  categories,
  syncDate,
}: HealthMissionsView) => {
  if (!categories.length) return <EmptySection />

  return (
    <Stack>
      <CollapsibleGroup divider>
        <CategoriesGrid>
          {categories.map((category) => (
            <Stack key={category.name} gap={2}>
              <HealthMissionCategoryHeader
                name={category.name}
                label={category.label}
              />
              {category.missions.slice(0, VISIBLE_MISSIONS).map((mission) => (
                <HealthMissionCard key={mission.name} {...mission} />
              ))}
              <CollapsibleBlock>
                <Stack gap={2}>
                  {category.missions.slice(VISIBLE_MISSIONS).map((mission) => (
                    <HealthMissionCard key={mission.name} {...mission} />
                  ))}
                </Stack>
              </CollapsibleBlock>
            </Stack>
          ))}
        </CategoriesGrid>
      </CollapsibleGroup>

      {isDefined(syncDate) && <SyncDate date={syncDate} />}
    </Stack>
  )
}

const CategoriesGrid = styled(Box)(({ theme: { breakpoints, spacing } }) => ({
  display: "grid",
  gridTemplateColumns: "1fr",
  [breakpoints.up("sm")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  gap: spacing(4),
  alignItems: "start",
}))
